import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import "./style.scss";

import CheckoutForm from "./Stripe";
const ELEMENTS_OPTIONS = {
  fonts: [
    {
      cssSrc: "https://fonts.googleapis.com/css?family=Roboto",
    },
  ],
};

const stripePromise = loadStripe(
  "pk_live_51JGP0HF5V5Cd7PZwPP5bRcbjm6RN5fLoWLxt0MMAjlgq0JW3l2249ycwPdOOcUga4sdBecRVvRf4yLKrlu596nPd00zUVKJIyK"
);

const App = (data) => {
  return (
    <div className="AppWrapper">
      <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
        <CheckoutForm
          tprice={data.location.state}
          total={data.location.state}
        />
      </Elements>
    </div>
  );
};

export default App;
